import {useMutation, useQueryClient} from '@github-ui/react-query'
import {fetchCAPI} from '../utils/fetch-capi'
import {agentTaskQueryKey} from './use-task'

interface UseUnarchiveTaskArgs {
  taskId?: string
  repoNwo?: string
}

export function useUnarchiveTask({taskId, repoNwo}: UseUnarchiveTaskArgs) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['unarchiveTask', repoNwo, taskId],
    mutationFn: async () => {
      if (!taskId || !repoNwo) {
        throw new Error('Cannot unarchive task: missing taskId or repoNwo')
      }
      const response = await fetchCAPI({
        path: `/agents/repos/${repoNwo}/tasks/${taskId}/unarchive`,
        method: 'POST',
      })
      return response
    },
    onSuccess: () => {
      const [repoOwner, repoName] = repoNwo?.split('/', 2) ?? []
      queryClient.invalidateQueries({queryKey: agentTaskQueryKey(repoOwner, repoName, taskId)})
      queryClient.invalidateQueries({queryKey: ['repo-tasks', repoOwner, repoName]})
    },
  })
}
